import { richTextModule } from "../guidePage/richTextModule";
import { infoBoxModule } from "../guidePage/infoBoxModule";
import { accordionModule } from "../guidePage/accordionModule";
import { quoteModule } from "../guidePage/quoteModule.js";
import { imageModule } from "../guidePage/imageModule.js";

export default class QuestionnaireModule {
  constructor(element) {
    this.el = element;
    //add this.answers as an array to the class and set it to an empty array
    this.answers = [];
    this.previousId;
    this.questionnaireContainer = this.el.querySelector(".questionnaire-container");
    this.startItem = this.el.dataset.startitem;
    this.questionnaireId = this.el.dataset.questionnaireid;
    this.GetQuestion = this.GetQuestion.bind(this);
    this.GenerateQuestion = this.GenerateQuestion.bind(this);
    this.GetResult = this.GetResult.bind(this);
    this.GenerateResult = this.GenerateResult.bind(this);
    this.UpdateAnswerArray = this.UpdateAnswerArray.bind(this);
    this.init();
  }
  init() {
    let startButton = this.el.querySelector("button");
    if (startButton && this.questionnaireId) {
      //add event listener to start button
      startButton.addEventListener("click", () => {
        this.GetQuestion(this.startItem);
      });
    }
  }

  GetQuestion(id) {
    const requestUrl = `/api/questionnaire/GetQuestion?id=${id}`;
    fetch(requestUrl)
      .then((response) => response.json())
      .then((result) => this.GenerateQuestion(result))
      .catch((error) => console.log("error", error));
  }

  GenerateQuestion(json) {
    const qusetionHtml = `
      <div class="col-span-12 lg:col-span-5 lg:col-start-2">
        <p class="text-blue text-headline2-lg font-black mb-6 lg:mb-10">${json.question}</p>
        <div class="mb-8">
          <p>${json.description}</p>
        </div>
        ${
          //find last item in this.answers. if item id is the same as json.id, set this.previousId to the answer to previous item id else set this.previousId last item in this.answers
          (this.answers.length > 0 ? (this.answers[this.answers.length - 1].id == json.id && this.answers.length > 1 ? (this.previousId = this.answers[this.answers.length - 2].id) : (this.previousId = this.answers[this.answers.length - 1].id)) : (this.previousId = this.startItem),
          json.id != this.startItem
            ? `
        <button class="group flex flex-nowrap lg:max-w-fit w-[calc(100%-48px)] bottom-[56px] lg:bottom-auto absolute justify-center items-center text-blue border rounded-[100px] border-blue text-base font-bold py-[10px] px-6 gap-4 duration-150 ease-in-out" data-backid="${this.previousId}">
          <svg class="h-6 w-6 fill-blue rotate-180">
            <use xlink:href="/spritemap.svg#sprite-dotarrow"></use>
          </svg>
          <span class="text-base text-blue font-bold">Forrige<span>
        </button>`
            : ``)
        }        
      </div>
      <div class="col-span-12 lg:col-span-4 lg:col-start-9">
        <ul>
        ${
          //map the answers in json.answers and return them as radiobuttons with the answer as label and nextID as value
          json.answers
            .map((answer, key) => {
              return `
            <li class="bg-white p-4 mb-4 flex flex-nowrap sm:items-center lg:items-start">
              <input class="cursor-pointer mr-4" type="radio" id="${key}" name="answer" value="${answer.nextId}" data-key=${answer.nextGuid} data-isResult="${answer.isNextResult}" ${this.answers.some((item) => item.id == json.id && item.answer == answer.nextId) ? `checked` : ``}>
              <label class="cursor-pointer" for="${key}">${answer.answer}</label>
            </li>
            `;
            })
            .join("")
        }
        </ul>
      </div>
    `;
    this.questionnaireContainer.addEventListener(
      "transitionend",
      () => {
        this.questionnaireContainer.innerHTML = "";
        this.questionnaireContainer.insertAdjacentHTML("beforeend", qusetionHtml);

        this.questionnaireContainer.classList.remove("fade-out");

        //find the radiobuttons and add eventlistener to them and call GetQuestion with the value of the radiobutton
        let radioButtons = this.questionnaireContainer.querySelectorAll("input[type=radio]");
        radioButtons.forEach((radioButton) => {
          radioButton.addEventListener("change", () => {
            this.UpdateAnswerArray(json.id, radioButton.value);
            if (radioButton.dataset.isresult == "true") {
              this.GetResult(radioButton.dataset.key);
            } else {
              this.GetQuestion(radioButton.value);
            }
          });
        });

        //find the back button and add eventlistener to it and call GetQuestion with the value of the back button
        let backButton = this.questionnaireContainer.querySelector("button[data-backid]");
        if (backButton) {
          backButton.addEventListener("click", () => {
            const backButtonId = backButton.dataset.backid;
            // Find the index of the item in this.answers with the matching ID
            const index = this.answers.findIndex((item) => item.id === backButtonId);
            this.answers.splice(index, 1);
            // Call GetQuestion with the value of the back button and the ID of the current question
            this.GetQuestion(backButtonId);
          });
        }
      },
      { once: true }
    );

    this.questionnaireContainer.classList.add("fade-out");
  }

  GetResult(key) {
    const requestUrl = `/umbraco/delivery/api/v1/content/item/${key}`;
    const requestOptions = { headers: { "Api-Key": "sesamsesam" } };

    fetch(requestUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("RESULT --->", result);
        this.GenerateResult(result);
      })
      .catch((error) => console.log("error", error));
  }

  GenerateResult(json) {
    let resultHtml = `
      <div class="col-span-12 lg:col-span-5">
        <div class="block mb-4 text-black text-sm font-normal">Dit resultat</div>
        <div class="text-blue text-2xl leading-9 lg:text-headline2-lg font-black mb-6 lg:mb-10">${json.properties.result}</div>
        <div class="mb-6 lg:mb-10">${json.properties.resultDesiption.markup}</div>
        <div class="mb-6">
          ${
            json.properties?.resultBlock
              ? `
            ${
              // Get the blocklist components
              json.properties?.resultBlock?.items
                .map((contentItem) => {
                  return this.generateGuidePageContent(contentItem);
                })
                .join("")
            }          
          `
              : ``
          }
        </div>
      </div>
      <div class="col-span-12 lg:col-span-5 lg:col-start-8">
          ${
            json.properties?.image
              ? `
            ${json.properties.image?.map((image) => {
              // Get the image
              return `
                <div class="aspect-square object-cover">
                  <img src=${image.url} alt=${image.name} />
                </div>
              `;
            })}                  
          `
              : ``
          }
      </div>
    `;

    this.questionnaireContainer.classList.add("fade-out");
    setTimeout(() => {
      this.questionnaireContainer.innerHTML = "";
      this.questionnaireContainer.classList.remove("fade-out");
      this.questionnaireContainer.insertAdjacentHTML("beforeend", resultHtml);
    }, 500);
  }

  generateGuidePageContent(json) {
    //create a function which returns the correct markup based on the content type
    let contentType = json.content.contentType;
    let content = "";
    switch (contentType) {
      case "richTextModule":
        content = richTextModule(json.content);
        break;
      case "infoBoxModule":
        content = infoBoxModule(json.content);
        break;
      case "accordionModule":
        content = accordionModule(json.content);
        break;
      case "imageModule":
        content = imageModule(json.content);
        break;
      case "quoteModule":
        content = quoteModule(json.content);
        break;
      default:
        return "";
    }
    return content;
  }

  initContentElements() {
    let contentElements = this.guideContainer.querySelectorAll("[data-component]");
    if (contentElements) {
      contentElements.forEach((item) => {
        switch (item.dataset.component) {
          case "rich-text":
            new RichText(item);
            break;
          case "accordion":
            new Accordion(item);
          default:
            break;
        }
      });
    }
  }

  UpdateAnswerArray(id, answer) {
    //if id exists in this.answers, then update the answer else add the id and answer to this.answers
    if (this.answers.some((item) => item.id == id)) {
      this.answers.find((item) => item.id == id).answer = answer;
    } else {
      this.answers.push({ id: id, answer: answer });
    }
  }
}
